import { io } from 'socket.io-client';

const SOCKET_PORT = '4233';
const BUILD_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// على localhost أو IP مباشر (شبكة محلية) → اتصل مباشرة على البورت
// غير هيك استخدم رابط الإنتاج من الـ env
const isDirectAddress = (host) =>
  host === 'localhost' ||
  host === '127.0.0.1' ||
  /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host);

const getSocketBase = () => {
  const host = window.location.hostname;
  if (isDirectAddress(host) || !BUILD_SOCKET_URL)
    return `http://${host}:${SOCKET_PORT}`;
  return BUILD_SOCKET_URL;
};

let socket = null;

export function connectSocket(token) {
  const socketUrl = getSocketBase();
  if (socket?.connected) {
    return socket; // في اتصال موجود → لا تنشئ جديد
  }

  socket = io(socketUrl, {
    auth: { token, device: 'mobile' }, // يُرسل بالـ handshake للمصادقة
    transports: ['websocket'], // WebSocket فقط (بدون polling fallback)
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket?.disconnect();
    socket = null;
  }
}
